import { OnboardingContactInformationSchema, POSTOnboardingLoginBody } from '@cbgms/api'
import useQuery from '@cbgms/base/http/use-query'
import { getShopContactInformation } from 'app/auth/state/actions'
import { useDispatch } from 'react-redux'
import { OnboardingMode } from '../onboarding/steps/types.d'
import { OnboardingState } from './use-onboarding-setup'

const getShopContactInformationCacheKey = (onboardingInfo: OnboardingState, credentials: POSTOnboardingLoginBody | undefined) => [
  'ONBOARDING',
  'SHOP_CONTACT_INFORMATION',
  onboardingInfo.shop,
  credentials
]
const emptyValues: OnboardingContactInformationSchema = {
  Name: '',
  VatIdentification: '',
  PhoneNumber: '',
  EmailAddress: '',
  VisitorCountry: null,
  VisitorPostalCode: '',
  VisitorHouseNumber: 0,
  VisitorHouseNumberAddition: '',
  VisitorAddress: '',
  VisitorAddressExtra: '',
  VisitorCity: '',
  VisitorState: '',
  VisitorLatitude: 0,
  VisitorLongitude: 0,

  PostalCountry: null,
  PostalPostalCode: '',
  PostalHouseNumber: '',
  PostalHouseNumberAddition: '',
  PostalAddress: '',
  PostalAddressExtra: '',
  PostalCity: '',
  PostalState: '',

  WebsiteURL: '',
  BankAccountIBAN: '',
  BankAccountBIC: '',
  CocIdentification: '',

  MGID: ''
}

const useGetShopContactInformation = (onboardingInfo: OnboardingState, wholesalerCredentials: POSTOnboardingLoginBody | undefined) => {
  const dispatch = useDispatch()
  return useQuery<OnboardingContactInformationSchema, unknown>(
    getShopContactInformationCacheKey(onboardingInfo, wholesalerCredentials),
    async () => {
      if (onboardingInfo.onboardingMode === OnboardingMode.OnboardingViaWholesaler) {
        const { Data } = await dispatch(getShopContactInformation(wholesalerCredentials!))
        if (Data) {
          return Data || emptyValues
        }
      }
      if (onboardingInfo.onboardingMode === OnboardingMode.OnboardingExistingShop) {
        return onboardingInfo.shop?.Data
          ? ({ ...emptyValues, ...(onboardingInfo.shop?.Data as any) } as OnboardingContactInformationSchema)
          : emptyValues
      }

      return emptyValues
    }
  )
}

export default useGetShopContactInformation
